import { Route, Switch, useRouteMatch } from 'react-router'
import { makeChildRoute } from '../../../../utils/CreateChildRoute'
import { updateBreadcrumbs } from '../Breadcrumbs'
import { EventListenerPage } from './EventListenerPage'
import { EventListenersDashboard } from './EventListenersDashboard'

export const EventListenersRouter = () => {
	const { path } = useRouteMatch()

	updateBreadcrumbs(`/_administration/_event-listeners`, 'Event Listeners')

	return (
		<Switch>
			<Route path={makeChildRoute(':eventListenerId', path)}>
				<EventListenerPage />
			</Route>
			<Route path={makeChildRoute('', path)}>
				<EventListenersDashboard />
			</Route>
		</Switch>
	)
}
